import { render, staticRenderFns } from "./payForSuccess.vue?vue&type=template&id=a81326d0&scoped=true&"
import script from "./payForSuccess.vue?vue&type=script&lang=js&"
export * from "./payForSuccess.vue?vue&type=script&lang=js&"
import style0 from "./payForSuccess.vue?vue&type=style&index=0&id=a81326d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a81326d0",
  null
  
)

export default component.exports